import { Manager } from "socket.io-client";

export var SocketIO = (function () {
    const fullPath = "https://tracker-api.beartoolkit.com";
    const manager = new Manager(fullPath, {
        path: "/socket",
        withCredentials: true
    });
    
    //const manager = new Manager("/", {path: "/socket"});
    var room = "";
    var socket = manager.socket("/HuntUpdate");

    const getSocket = () => {
        return socket;
    };

    const setRoomID = (id) => {
        room = id;
        socket.emit("Change Room Request", id);
    };

    socket.on("connect", () => {
        if (room != "") {
            socket.emit("Change Room Request", room);
        }
    });

    return {
        getSocket: getSocket,
        setRoomID: setRoomID,
    }
})();